import Paper from "@mui/material/Paper";
import React from "react";

function Card({ styles, children, elevation =  2 }) {
  return (<Paper sx={styles} elevation={elevation}>{children}</Paper>);
}

export default Card;
